import React, { useState } from 'react';
import { ResourcesV1 } from './pages/ResourcesV1';
import { ResourcesV2 } from './pages/ResourcesV2';
import { ResourcesV3 } from './pages/ResourcesV3';
export function App() {
  const [version, setVersion] = useState<'v1' | 'v2' | 'v3'>('v1');
  return <div data-id="element-0">
      {/* Version Switcher - For Demo Purposes Only */}
      <div className="fixed bottom-4 right-4 z-[100] bg-white p-2 rounded-full shadow-2xl border border-gray-200 flex gap-2" data-id="element-1">
        <button onClick={() => setVersion('v1')} className={`px-4 py-2 rounded-full text-sm font-bold transition-all ${version === 'v1' ? 'bg-brand-navy text-white shadow-md' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-2">
          V1: Clean
        </button>
        <button onClick={() => setVersion('v2')} className={`px-4 py-2 rounded-full text-sm font-bold transition-all ${version === 'v2' ? 'bg-brand-accent text-white shadow-md' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-3">
          V2: Emotion
        </button>
        <button onClick={() => setVersion('v3')} className={`px-4 py-2 rounded-full text-sm font-bold transition-all ${version === 'v3' ? 'bg-green-600 text-white shadow-md' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-4">
          V3: Simple
        </button>
      </div>

      {/* Page Content */}
      {version === 'v1' && <ResourcesV1 data-id="element-5" />}
      {version === 'v2' && <ResourcesV2 data-id="element-6" />}
      {version === 'v3' && <ResourcesV3 data-id="element-7" />}
    </div>;
}